import { useContext, useEffect } from 'react'
import { HomePageHero } from '../../components/HomePageHero'
import JobRoles from '../../components/seeker/JobRoles'
import USP from '../../components/seeker/USP'
import States from '../../components/seeker/States'
import Delhi from '../../../public/assets/delhi.svg'
import Andhra from '../../../public/assets/andhra pradesh.svg'
import Kerela from '../../../public/assets/kerala.svg'
import Tamil from '../../../public/assets/tamil nadu.svg'
import Telengana from '../../../public/assets/telangana.svg'
import Gujrat from '../../../public/assets/gujarat.svg'
import Karnataka from '../../../public/assets/karnataka.svg'
import Maharashtra from '../../../public/assets/maharashtra.svg'
import Services from '../../components/seeker/Services'
import Medical from '../../../public/assets/roles_medical.webp'
import Sales from '../../../public/assets/roles_field_sales.webp'
import Banking from '../../../public/assets/roles_banking.webp'
import Tele from '../../../public/assets/roles_telecalling.webp'
import Factory from '../../../public/assets/roles_factory_worker.webp'
import Accounts from '../../../public/assets/roles_accounts.webp'
import Business from '../../../public/assets/roles_business_developmnt.webp'
import Data from '../../../public/assets/roles_data_entry.webp'
import Delivery from '../../../public/assets/roles_delivery.webp'
import Teaching from '../../../public/assets/roles_teaching.webp'
import Companies from '../../components/seeker/Companies'
import Testimonials from '../../components/seeker/Testimonials'
import RecruiterBanner from '../../components/seeker/RecruiterBanner'
import USPDesktop from '../../components/seeker/USPDesktop'
import StateDesktop from '../../components/seeker/StatesDesktop'
import ServicesDesktop from '../../components/seeker/ServicesDesktop'
import TestimonialsDesktop from '../../components/seeker/TestimonialsDesktop'
import RecruiterBannerDesktop from '../../components/seeker/RecruiterBannerDesktop'
import SeekerHeader from '../../components/seeker/SeekerHeader'
import { useState } from 'react'
import Logo from '../../../public/assets/color.webp'
import { FrequentlyAskedQues } from '../../components/FrequentlyAskedQues'
import { QuickAccessFooter } from '../../components/QuickAccessFooter'
import { Footer } from '../../components/Footer'
import Image from 'next/image'
import {
  ADVERTISER_CATEGORIES,
  FrequentlyAskedQuesData,
  LOCATION_ENDPOINT
} from '../../constants/all'
import Head from 'next/head'
import { Media } from '../../commonComponents/Media'
import { DesktopSeekerFooter } from '../../components/DesktopSeekerFooter'
import { multipleGetCalls, sortListBykeyInObject } from '../../utils/functions'
import { CustomerServices } from '../../commonComponents/HomePageComponents'
import { seekersPageScripts } from '../_app'
import { trackEvent } from '../../analytics'
import { useRouter } from 'next/router'
import { seekersAnalayticOptions } from '../../utils/functions'
import CompaniesDesktop from '../../components/seeker/CompaniesDesktop'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import classNames from 'classnames'
import { Button, Modal } from 'antd'
import Snackbar from '@mui/material/Snackbar'
import DoneIcon from '@mui/icons-material/Done'
import { useRef } from 'react'
import DownloadLinkSentSuccess from '@/components/seeker/DownloadLinkSentSuccess'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import SeekerHeaderDesktop from '../../../src/components/seeker/SeekerHeaderDesktop'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'

const HomePage = ({ footerCategories, footerLocations, categories }) => {
  const {
    setUtmParams,
    loginDetails,
    location,
    windowSize
  } = useContext(SharedContext);
  
  const {
    showCopyToast: toast,
    setShowCopyToast: setToast,
    isLoginOpen
  } = useContext(SeekerContext);

  const [modalOpen, setModalOpen] = useState(false)
  const [phone, setPhone] = useState('')
  const menuRef = useRef()
  const [isSent, setIsSent] = useState(false)
  const [showToast, setShowToast] = useState({
    status: false,
    text: ''
  })

  let allStates = [
    {
      id: 1,
      name: 'Andhra Pradesh',
      districts: '23',
      thumb: Andhra,
      background: '#FFF8DC'
    },
    {
      id: 2,
      name: 'Telangana',
      districts: '22',
      thumb: Telengana,
      background: '#FFF1DA'
    },
    {
      id: 3,
      name: 'Kerala',
      districts: '32',
      thumb: Kerela,
      background: '#FFE3E7'
    },
    {
      id: 4,
      name: 'Tamil Nadu',
      districts: '33',
      thumb: Tamil,
      background: '#FFF6E4'
    },
    {
      id: 5,
      name: 'Gujarat',
      districts: '11',
      thumb: Gujrat,
      background: '#F5F5F5'
    },
    {
      id: 6,
      name: 'Karnataka',
      thumb: Karnataka,
      districts: '22',
      background: '#FFF5E0'
    },
    {
      id: 7,
      name: 'Delhi',
      thumb: Delhi,
      districts: '2',
      background: '#FFF4ED'
    },
    {
      id: 8,
      name: 'Maharashtra',
      thumb: Maharashtra,
      districts: '12',
      background: '#FFF4ED'
    }
  ]
  const [showMenu, setShowMenu] = useState(false)

 

  let services = [
    { id: 1, name: 'Medical', image: Medical },
    { id: 2, name: 'Delivery', image: Delivery },
    { id: 3, name: 'Telecalling', image: Tele },
    { id: 4, name: 'Banking', image: Banking },
    { id: 5, name: 'Teaching', image: Teaching },
    { id: 6, name: 'Field Sales', image: Sales },
    { id: 7, name: 'Factory Worker', image: Factory },
    { id: 8, name: 'Data Entry', image: Data },
    { id: 9, name: 'Business', image: Business },
    { id: 10, name: 'Account', image: Accounts }
  ]
  const router = useRouter()
  useEffect(() => {
    trackEvent({
      name: 'seeker_home_page_viewed',
      searchParams: {
        ...(router?.query || {})
      },
      options: seekersAnalayticOptions(
        window,
        loginDetails,
        location,
        'impression',
        'job_seeker_home'
      ),
      isSeeker: true
    })
    setUtmParams(router?.query || {})
    window.addEventListener('scroll', () => {
      setShowMenu(false)
    })
  }, [])

  useEffect(() => {
    if (router.asPath == '/jobs' || router.asPath == '/jobs/') {
      localStorage.removeItem('location')
    }
  }, [])

  return (
    <div className="flex items-center justify-center">
      <Head>
        <title>98267+ Find Jobs & Vacancies - Start Your Job Search</title>
        <meta name="title" content="98267+ Find Jobs & Vacancies - Start Your Job Search" />
        <meta
          name="description"
          content="Find dream jobs near me in less than 24 hours with our latest vacancies. Sign up now and get job alerts when the perfect role is available!"
        />
        <meta
          property="og:description"
          content="Find dream jobs near me in less than 24 hours with our latest vacancies. Sign up now and get job alerts when the perfect role is available!"
        />
        <meta property="og:title" content="98267+ Find Jobs & Vacancies - Start Your Job Search" />
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_APP_URL}assets/seeker_open_graph.jpg`}
        />
        <meta
          property="twitter:description"
          content="Find dream jobs near me in less than 24 hours with our latest vacancies. Sign up now and get job alerts when the perfect role is available!"
        />
        <meta
          property="twitter:title"
          content="98267+ Find Jobs & Vacancies - Start Your Job Search"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {seekersPageScripts()}
        <div
          className={classNames(`flex h-full w-full flex-col relative`, showMenu && `backdrop`)}
          id="home_page"
          ref={menuRef}
        >
          <div id="nav-container" className="flex flex-col items-center">
            <div
              id="seeker-nav"
              className={classNames(
                `fixed z-[999] mt-[8px] flex w-[95%] items-center justify-between border-solid border-customBorder bg-white p-[16px]`,
                showMenu && windowSize < 1100 ? 'rounded-t-[16px]' : 'rounded-[16px]'
              )}
            >
              <div id="left">
                <div id="logo" className="hidden md:flex">
                  <Image src={Logo} width={136} height={21} alt='lokal_app' />
                </div>
                <div id="logo" className="md:hidden">
                  <Image src={Logo} width={90} height={14} alt='lokal_app' />
                </div>
              </div>
              <div id="right" className="flex items-center gap-[12px]">
                <div className="sm:hidden">
                  {' '}
                  <Button
                    className="border-secondary bg-secondary font-noto-sans text-[12px] font-[600] text-greyTitleBase900"
                    style={{ width: '100%', paddingLeft: '16px', paddingRight: '16px' }}
                    onClick={() => {
                      router.push(
                        'https://play.google.com/store/apps/details?id=get.lokal.localjobs&hl=en_IN'
                      )
                    }}
                  >
                      Download App
                  </Button>
                </div>
                <div className="hidden items-center gap-[20px] md:flex">
                  <Button className="font-noto-sans text-[14px] font-bold text-greyTitleBase900" onClick={()=>{
                    router.push('/hire')
                  }}>
                    Looking to hire?
                  </Button>
                  <Button className="font-noto-sans text-[14px] font-bold text-greyTitleBase900" onClick={()=>{
                    router.push('/jobs/jobs-near-me')
                  }}>
                    Search Jobs
                  </Button>
                </div>

                <div
                  className="md:hidden"
                  onClick={(e) => {
                    setShowMenu((p) => !p)
                  }}
                >
                  <MenuRoundedIcon />
                </div>

                <div
                  className="ml-[10px] hidden md:inline-block"
                  onClick={(e) => {
                    setShowMenu((p) => !p)
                  }}
                >
                  <AccountCircleOutlinedIcon sx={{ height: '25px', width: '25px' }} />
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="flex sm:justify-center sm:bg-white">
              <Media at="sm">
                <div className="w-[100%]" id="home_page_hero">
                  <HomePageHero />
                  <JobRoles />
                  <USP />
                  <States states={allStates} />
                  <Services services={services} />
                  <Companies />
                  <Testimonials />
                  <div className='flex justify-center' >
                  <RecruiterBanner />
                  </div>
                </div>
              </Media>
              <Media greaterThan="sm" className='w-full'>
                <div className="pb-[40px] sm:text-center" id="home_page_hero">
                  <HomePageHero
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    isSent={isSent}
                    setIsSent={setIsSent}
                  />
                  <USPDesktop />
                  <StateDesktop states={allStates} />
                  <ServicesDesktop services={services} />
                  <CompaniesDesktop />
                  <TestimonialsDesktop />
                  {isSent && (
                    <Modal open={isSent} closable className="w-[45%]">
                      <div
                        className="flex w-[100%] cursor-pointer justify-end px-[24px] pt-[5px] text-[20px] font-bold"
                        onClick={() => {
                          setModalOpen(false)
                          setIsSent(false)
                        }}
                      >
                        X
                      </div>
                      <DownloadLinkSentSuccess setIsSent={setIsSent} number={phone} />
                    </Modal>
                  )} 
                </div>
              </Media>
            </div>
            <div className="md:flex md:w-full">
              <div className="bg-white px-[12px] pt-[56px] pb-[40px] sm:pl-[36px] sm:pr-[28px] sm:pt-[64px] sm:pb-[44px] md:flex-1 md:px-[60px] md:py-[40px]">
                <FrequentlyAskedQues
                  data={FrequentlyAskedQuesData}
                  containerClassName={'bg-white'}
                />
              </div>
            </div>
            <Media greaterThan="sm">
              <RecruiterBannerDesktop />
            </Media>
            <Media at="sm">
              <QuickAccessFooter />
              <Footer />
            </Media>
            <Media at="md">
              <QuickAccessFooter />
              <Footer />
            </Media>
            <Media greaterThan="md">
              <DesktopSeekerFooter {...{ footerCategories, footerLocations }} />

              <div className="h-fit" style={{ backgroundColor: '#F9F9F9' }}>
                <CustomerServices />
              </div>
            </Media>
          </div>
          {showToast.status && (
            <Snackbar
              open={open}
              autoHideDuration={2000}
              onClose={() => {
                setShowToast((p) => {
                  return {
                    ...p,
                    status: !p.status
                  }
                })
              }}
              message={
                <div className="flex items-center gap-[9px]">
                  {' '}
                  <DoneIcon /> {showToast.text} copied
                </div>
              }
            />
          )}
          {toast && (
            <Snackbar
              open={open}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              autoHideDuration={2000}
              onClose={() => {
                setToast(false)
              }}
              message={
                <div className="flex items-center gap-[9px]">
                  {' '}
                  <DoneIcon /> Copied to clipboard
                </div>
              }
            />
          )}
          {showMenu && (
            <div className="md:hidden flex flex-col items-center">
              <SeekerHeader
                setShowToast={setShowToast}
                isLogin={isLoginOpen}
                setShowMenu={setShowMenu}
                menuRef={menuRef}
              />
            </div>
          )}
          {showMenu && (
            <div className="hidden md:flex justify-end">
              <SeekerHeaderDesktop setShowMenu={setShowMenu} setShowToast={setShowToast}/>
            </div>
          )}
        </div>
    </div>
  )
}

export default HomePage

export const getStaticProps = async () => {
  const apiDetails = [
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + ADVERTISER_CATEGORIES,
      params: { only_top: 1 }
    },
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_API + LOCATION_ENDPOINT,
      params: { level: 1 }
    }
  ]

  const res = await multipleGetCalls(apiDetails)

  return {
    props: {
      footerCategories: sortListBykeyInObject({ list: res?.[0], key: 'title' }),
      footerLocations: sortListBykeyInObject({ list: res?.[1]?.results, key: 'title' }).slice(0, 8)
    }
  }
}
